import React, { Component } from 'react';
import './index.css';

const WARNING_THRESHOLD = 60;
const ALERT_THRESHOLD = 30;
const FULL_DASH_ARRAY = 283;
const COLOR_CODES = {
    info: { color: "green" },
    warning: { color: "orange", threshold: WARNING_THRESHOLD },
    alert: { color: "red", threshold: ALERT_THRESHOLD },
    gray: { color: "#F2F4F5" }
};

const TOTAL_SECONDS = 24 * 60 * 60;

class CircleCountdownTimer extends Component {

    calculateTimeFraction() {
        const timeLeft = this.props.hours * 60.0 * 60.0 + this.props.mins * 60 + this.props.secs        
        return `${FULL_DASH_ARRAY * (timeLeft / TOTAL_SECONDS)} 283`
    }

    percent() {
        const timeLeft = this.props.hours * 60 * 60 + this.props.mins * 60 + this.props.secs
        return (timeLeft / TOTAL_SECONDS * 100 ).toFixed(0)
    }

    twodigits(n){
        if(n < 0) 
            return n;
        return n > 9 ? "" + n: "0" + n;
    }
    
    render() {
        return (
            <div id="timer" style={{display: this.props.displayState ? "block" : "none"}}>
                <div className="base-timer">
                    <svg className="base-timer__svg" viewBox="0 0 100 100">
                        <g className="base-timer__circle">
                            {/* <circle className="base-timer__path-elapsed " cx="50" cy="50" r="45"></circle> */}
                            <path id="base-timer-path-remaining"
                                d="M 50, 50 m -45, 0 a 45,45 0 1,0 90,0 a 45,45 0 1,0 -90,0"
                                strokeDasharray="283"
                                style={{
                                    color: COLOR_CODES.gray.color,
                                    strokeDasharray: '283 283'
                                }}
                                className='base-timer__path-remaining'>
                            </path>
                            <path id="base-timer-path-remaining"
                                d="M 50, 50 m -45, 0 a 45,45 0 1,0 90,0 a 45,45 0 1,0 -90,0"
                                strokeDasharray="283"
                                style={{
                                    color: this.percent() <= ALERT_THRESHOLD ? COLOR_CODES.alert.color :
                                        this.percent() <= WARNING_THRESHOLD ? COLOR_CODES.warning.color : COLOR_CODES.info.color,
                                    strokeDasharray: this.calculateTimeFraction()
                                }}
                                className='base-timer__path-remaining'>
                            </path>
                        </g>
                    </svg>
                    <span className="base-timer__label">{`${this.twodigits(this.props.hours)}:${this.twodigits(this.props.mins)}:${this.twodigits(this.props.secs)}`}</span>
                </div>
            </div>
        );
    }
}

export default CircleCountdownTimer;